/* globals Parsley */

import {modalsBehavior} from './modals.js';
import {helpers} from '../common/helpers.js';

Parsley.addMessages('ru', {
	defaultMessage: 'Некорректное значение.',
	type: {
		email: 'Введите адрес электронной почты.',
		url: 'Введите URL адрес.',
		number: 'Введите число.',
		integer: 'Введите целое число.',
		digits: 'Введите только цифры.',
		alphanum: 'Введите буквенно-цифровое значение.',
	},
	notblank: 'Это поле должно быть заполнено.',
	required: 'Обязательное поле.',
	pattern: 'Это значение некорректно.',
	min: 'Это значение должно быть не менее чем %s.',
	max: 'Это значение должно быть не более чем %s.',
	range: 'Это значение должно быть от %s до %s.',
	minlength: 'Это значение должно содержать не менее %s символов.',
	maxlength: 'Это значение должно содержать не более %s символов.',
	length: 'Это значение должно содержать от %s до %s символов.',
	mincheck: 'Выберите не менее %s значений.',
	maxcheck: 'Выберите не более %s значений.',
	check: 'Выберите от %s до %s значений.',
	equalto: 'Это значение должно совпадать.',
});

Parsley.setLocale('ru');

function checkInputFill($elem) {
	let inputValue = $elem.val().trim();

	if (inputValue) {
		$elem.siblings('.label-like').addClass('is-inputfilled');
	} else {
		$elem.siblings('.label-like').removeClass('is-inputfilled');
	}

	$elem.val(inputValue);
}

function clearForm($form) {
	let $inputs = $form.find('input, textarea').not('input[type="checkbox"], input[type="hidden"]');

	$inputs.each((i, elem) => {
		$(elem).val('');
		checkInputFill($(elem));
	});

	$form.removeClass('is-pending');
}

function initForms() {
	$('input[type="tel"]').on('keydown', (e) => {
		helpers.onlyNumbers(e);
	});

	$('.form input, .form textarea').on('focusout', (e) => {
		let $elem = $(e.currentTarget);

		checkInputFill($elem);
	});

	let validatorOptions = {
		classHandler(ParsleyField) {
			return ParsleyField.$element.closest('label');
		},
		errorsContainer(ParsleyField) {
			return ParsleyField.$element.siblings('.validator-errors');
		},
		errorsWrapper: '<ul class="error-messages"></ul>',
		errorTemplate: '<li></li>',
	};

	$('.form').not($('.modal-form .form')).parsley(validatorOptions);
	$('.modal-form .form').parsley({
		classHandler(ParsleyField) {
			return ParsleyField.$element.closest('label');
		},
		errorsContainer(ParsleyField) {
			return ParsleyField.$element.siblings('.validator-errors');
		},
		errorsWrapper: '<ul class="error-messages"></ul>',
		errorTemplate: '<li></li>',
		focus: 'none',
	});

	$('.form').on('submit', (e) => {
		let $form = $(e.currentTarget);
		let $statusContainer = $(e.currentTarget).closest('.modal-form').find('.modal__formstatus');

		if ($form.hasClass('is-pending')) {
			return false;
		}

		e.preventDefault();

		$form.parsley().validate();

		if ($form.parsley().isValid()) {

			try {
				var form_name = $form.data('form-name');

				switch( form_name ){
					case 'question':
						( typeof window.dsp_question == 'function' ) && window.dsp_question();
						break;
					case 'consult':
						( typeof window.dsp_consult == 'function' ) && window.dsp_consult();
						break;
					case 'overview':
						var _rutarget = window._rutarget || [];
						_rutarget.push({'event': 'thankYou', 'conv_id': 'order'});
						( typeof window.dsp_overview == 'function' ) && window.dsp_overview();
						break;
				}

				switch( window.__current_section ){
					case 'index':
						ym(51706139,'reachGoal','main_forms');
						gtag('event', 'main_forms_success', { 'event_category' : 'zayavka' });
						break;
					case 'park':
						switch( window.__current_slug ){
							case 'futuro':
								ym(51706139,'reachGoal','fut_form');
								gtag('event', 'fut_form_success', { 'event_category' : 'zayavka' });
								break;
							case 'avenue':
								ym(51706139,'reachGoal','ave_form');
								gtag('event', 'ave_form_success', { 'event_category' : 'zayavka' });
								break;
							case 'fonte':
								ym(51706139,'reachGoal','font_form');
								gtag('event', 'font_form_success', { 'event_category' : 'zayavka' });
								break;
						}
						break;
					case 'about':
						ym(51706139,'reachGoal','company_form');
						gtag('event', 'company_form_success', { 'event_category' : 'zayavka' });
						break;
					case 'contacts':
						ym(51706139,'reachGoal','cont_form');
						gtag('event', 'cont_form_success', { 'event_category' : 'zayavka' });
						break;
				}
			}catch(e) {
				console.log('Some stat event error occured');
			}
			
			$form.addClass('is-pending');

			let content = $form.siblings('.form-success-cont').html();

			if ($statusContainer.length) {
				$statusContainer.addClass('is-pending').removeClass('is-start');
			}

			var form_data = $form.serialize(),
				form_fields = $form.serializeArray(),
				comagic_data = {};
			form_fields.forEach(function(elm){ comagic_data[elm.name] = elm.value; });

			$.ajax({
				type: 'POST',
				url: '/send/callback',
				data: form_data,
				success(data) {
					modalsBehavior.show('formsuccess', content);
					clearForm($form);

					if ($statusContainer.length) {
						$statusContainer.removeClass('is-pending is-start');
					}
				},
				error() {
					clearForm($form);

					if ($statusContainer.length) {
						$statusContainer.removeClass('is-pending is-start is-start--1 is-start--2 is-start--3');
					}
				},
			});

			try {
				Comagic.addOfflineRequest(comagic_data);
			}catch(e){

			}
		}
	});

	$('.modal-form input').on('keydown keyup keypress', (e) => {
		let progressCheck = 0;
		let $inputs = $(e.currentTarget).closest('form').find('input').not('input[type="checkbox"], input[type="hidden"]');
		let $statusContainer = $(e.currentTarget).closest('.modal-form').find('.modal__formstatus');

		$inputs.each((i, elem) => {
			if ($(elem).val() !== '') {
				progressCheck += 1;
			}
		});

		if (progressCheck === 0) {
			$statusContainer.removeClass('is-start is-start--1 is-start--2 is-start--3');
		} else {
			$statusContainer.removeClass('is-start is-start--1 is-start--2 is-start--3');
			$statusContainer.addClass(`is-start is-start--${progressCheck}`);
		}
	});
}

if (helpers.isHeroShown) {
	initForms();
} else {
	$(document).one('hero.isShown', () => {
		initForms();
	});
}
